import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const CONTRACT_PERMISSIONS = {
  READ: PERMISSIONS.CONTRACTS_READ,
  WRITE: PERMISSIONS.ORGS_WRITE,
};

export const CONTRACT_QUERY_KEYS = queryKeys.contracts;
